import React from 'react';
import { cx } from '@/styled-system/css';
import * as styles from './mediaCenter.styles';

type FilterPillConfig = {
  label: string;
  active: boolean;
  disabled: boolean;
};

type FilterPillsProps = {
  pills: Array<FilterPillConfig>;
  onPillClick?: (label: string) => void;
};

export const FilterPills = ({ pills, onPillClick }: FilterPillsProps) => (
  <div className={styles.pillsContainer} role="group" aria-label="Photo filters">
    {pills.map((pill) => (
      <button
        key={pill.label}
        className={cx(styles.pill, pill.active ? styles.pillActive : styles.pillInactive)}
        aria-pressed={pill.active}
        disabled={pill.disabled}
        onClick={() => onPillClick?.(pill.label)}
      >
        {pill.label}
      </button>
    ))}
  </div>
);
